module.exports = __webpack_public_path__ + "img/clue_chromebook_login.585c0118.png";